import { Route, Routes } from 'react-router-dom';
import { AccountInfo } from './thong-tin';
import MySignatures from './chu-ky';

export const Account = () => {
    return (
        <Routes>
            <Route path="thong-tin" element={<AccountInfo />}></Route>
            <Route path="chu-ky" element={<MySignatures />}></Route>
        </Routes>
    );
};